import { ISystemContext } from "../../../../Context/SystemContext";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { BonusConfigurationList, SlotGameInitData } from "../../../../SlotGameInitData";
import { Translator } from "../../../../Translator";
import { ISize, LogGroup, Scale, Size } from "../../../.././MyHelpers";
import { Settings } from "../../../../Settings";
import { ISlideFactory2Side } from "../SlideFactory2Side";

export interface SlideFactory2Params
{
    gameName: string,
	path: string;
	commonPath: string;
	resid: ResourceIdentifier;
	logGroup: LogGroup;
	slideFactory: ISlideFactory2Side;
	translator: Translator;
	params: BonusConfigurationList;
	systemContext: ISystemContext;
}

export abstract class Slide {
	protected initData: SlotGameInitData = null;
	protected p: SlideFactory2Params;
	
    protected view: HTMLElement = null;
    protected path: string = "";
    protected commonPath: string = "";
    //protected resid: ResourceIdentifier = null;S
    protected translator: Translator;

    protected commonPath2: string = null;

    //protected logGroup: LogGroup = null;

    protected readonly nextAnimInterval: number = 5000; //18*1000;

    protected viewSize : ISize = {Width: Scale.W(763), Height: Scale.H(582)}


    public constructor(initData: SlotGameInitData, p: SlideFactory2Params , viewSize:ISize) {
		this.initData = initData;
		this.p = p;
        this.path = p.path;
        this.commonPath = p.commonPath;
        this.translator = p.translator;
        this.commonPath2 = Settings.ResourcesFolder + "multigame/slot/common/resources/";
        this.viewSize = viewSize;
    }

    public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
    }

    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
    }

    public View(): HTMLElement {
        return this.view;
    }

    public Update() {
    }

    public Start() {
	}
	
    public Stop() {
    }
}
